import * as React from 'react';

import {CloseButton} from 'shells/button/close-button/close-button';
import {ChannelPicker} from 'shells/channels/channel-picker';
import type {ChannelType} from 'shells/channels/types';
import {SourcesSelect} from 'shells/lead-sidebar/sources/sources-select';

import type {SourceFragment as Source} from 'nutshell-graphql-types';

import type {CreatableState} from './channel-source-creatable-row';

type Props = {
    creatableState: CreatableState;
    onSelectChannel: (channel: ChannelType) => void;
    onSelectSource: (sourceId: string) => void;
    sourceOptions: Source[];
    canAccessSetup: boolean;
    onCancel: () => void;
    existingChannels: ChannelType[];
};

export function ChannelSourceRowSelectState(props: Props) {
    const {onCancel} = props;

    const [isBlurEnabled, setIsBlurEnabled] = React.useState(false);

    React.useEffect(() => {
        // Enable blur handling after a short delay to prevent immediate cancellation
        const timer = setTimeout(() => {
            setIsBlurEnabled(true);
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    const handleBlur = React.useCallback(() => {
        if (isBlurEnabled) {
            onCancel();
        }
    }, [isBlurEnabled, onCancel]);

    return (
        <div className='flex gap-4 justify-sb'>
            <div className='full-width'>
                {props.creatableState === 'channel' ? (
                    <ChannelPicker
                        onSelectChannel={props.onSelectChannel}
                        minHeight={24}
                        existingChannels={props.existingChannels}
                        onBlur={handleBlur}
                        autoFocus={true}
                        preventScrollOnMenuOpen={false}
                        menuZIndex={11}
                    />
                ) : (
                    <SourcesSelect
                        onSelectSource={props.onSelectSource}
                        minHeight={24}
                        sourceOptions={props.sourceOptions}
                        canAccessSetup={props.canAccessSetup}
                        onBlur={handleBlur}
                        preventScrollOnMenuOpen={false}
                        menuZIndex={11}
                    />
                )}
            </div>
            <CloseButton variant='dark' onClick={props.onCancel} size={10} />
        </div>
    );
}
